// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1b66{gap:var(--ds-space-050,4px)}._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bah1e5h{justify-content:left}\n._1bsb1wug{width:auto}\n._1e0c1txw{display:flex}\n._1tke1tcg{min-height:24px}\n._4cvr1h6o{align-items:center}\n._80omtlke{cursor:pointer}\n._otyr1b66{margin-bottom:var(--ds-space-050,4px)}\n._syaz1e6v{color:var(--ds-text-brand,#0c66e4)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
